import React from 'react';
import PropTypes from 'prop-types';
import './NotFound.scss';
function NotFound(_ref) {
  var root = _ref.root,
    logoUrl = _ref.logoUrl,
    notFoundUrl = _ref.notFoundUrl,
    backdropUrl = _ref.backdropUrl,
    explanation = _ref.explanation;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "backdrop-div"
  }, /*#__PURE__*/React.createElement("img", {
    src: backdropUrl,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "backdrop-div not-found-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel panel-default not-found-panel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-content"
  }, /*#__PURE__*/React.createElement("img", {
    src: logoUrl,
    className: "logo-image",
    alt: ""
  }), /*#__PURE__*/React.createElement("img", {
    src: notFoundUrl,
    className: "not-found-image",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "ooops-div"
  }, "Ooops"), /*#__PURE__*/React.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/React.createElement("div", {
    className: "explanation-div"
  }, explanation), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-primary",
    href: root
  }, "Take Me Home", /*#__PURE__*/React.createElement("div", {
    className: "glyphicon glyphicon-menu-right"
  }))))));
}
NotFound.propTypes = {
  root: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  notFoundUrl: PropTypes.string.isRequired,
  backdropUrl: PropTypes.string.isRequired,
  explanation: PropTypes.string.isRequired
};
export default NotFound;